import ApplicationController from '../application_controller'
import Fetchers from 'core/fetchers'
import Utilities from 'shared/helpers/ProductHelper/utilities'

export default class CartActionController extends ApplicationController {
  static outlets = ['navigation--tray-trigger', 'navigation--cart']

  static values = {
    designId: Number,
    storeId: Number,
  }

  addToCart(event) {
    const currentTarget = event.currentTarget;
    const { ProductOptions } = window.TeePublic;
    const { hierarchy } = ProductOptions.CanvasOptions;
    const selections = Utilities.collectSelections('form.jsConfigOptions', ProductOptions, false);
    const valid = Utilities.validateAddToCart(selections, hierarchy, false);
    if (!valid) return;

    const sanitizedProducts = Utilities.sanitizeProducts(ProductOptions);
    const product = Utilities.findProductFromSelections(sanitizedProducts, selections, ProductOptions);
    const quantity = parseInt(document.querySelector('#jsProductPageQuantity')?.value || 1);

    const postOptions = {
      product_id: product.id,
      design_id: this.designIdValue,
      quantity,
      store_id: this.storeIdValue || null,
      campaign_id: window.TeePublic.campaign.id,
    };

    if (
      window.dataLayer &&
      event.target &&
      !event.target.classList.contains('jsDasheryAddToCart')
    ) {
      const selectionsFullText = Utilities.collectFullTextSelections('form.jsConfigOptions', hierarchy, true);
      window.TeePublic.ProductVendorHelper
        .updateDataLayerAddToCart(postOptions, selections, selectionsFullText, product);
    }

    Fetchers.fetchJSON('/add_to_cart', 'POST', JSON.stringify(postOptions))
      .then(res => res.json())
      .then((data) => {
        if (!data.success) throw new Error('Network response was not ok');

        this.updateBadgeNotification(quantity);
        this.navigationCartOutlet.fireRequestValue = true;
        this.navigationTrayTriggerOutlet.lazyloadCartTray({ currentTarget });
        window.addEventListener('lazyload', () => this.showSuccessNoteMessage(quantity), { once: true });
      })
      .catch(() => alert('This product is no longer available.'));
  }

  showSuccessNoteMessage(quantity) {
    const itemText = quantity == 1 ? 'item' : 'items';
    this.navigationCartOutlet.successMessageQuantityTarget.textContent = `${quantity} ${itemText} added to cart!`
    this.navigationCartOutlet.cartUpdateSuccessMessageTarget.classList.remove('hidden')
  }

  updateBadgeNotification(itemCount) {
    const badges = document.querySelectorAll('.jsNotificationBadge');

    badges.forEach((badge) => {
      const badgeNotification = badge.notification;
      const badgeValue = parseInt(badgeNotification.countValue) || 0;
      badgeNotification.countValue = badgeValue + itemCount;
      badgeNotification.updateCount();
    })
  }
}
